
import { Component, Vue, Watch } from 'vue-property-decorator';
import { store, StoreMutations, FiltriSpedizioni } from '@/store';
import dayjs from 'dayjs';

@Component
export default class OpzioniSpedizioni extends Vue {

    @Watch("$store.state.ui.opzioniVisibili")
    onOpzioniOpened(isOpenNew: boolean, isOpenOld: any) {
        if(isOpenNew && isOpenNew != isOpenOld) {
            // caricamento filtro corrente
            this.filtroNumSpedizione = store.state.uiSpedizioni.filtri.numSpedizione;
            this.filtroDataSpedizioneDa = store.state.uiSpedizioni.filtri.dataSpedizioneDa;
            this.filtroDataSpedizioneA = store.state.uiSpedizioni.filtri.dataSpedizioneA;
        }
    }
    public menu1: boolean=false;
    private menu2: boolean=false;

    private filtroNumSpedizione: string = '';
    private date: string = '';
    public filtroDataSpedizioneDa: string = '';
    public filtroDataSpedizioneDaFormatted: string = '';
    private filtroDataSpedizioneA: string = '';
    private filtroDataSpedizioneAFormatted: string = '';

   private annullaModificaFiltro() {
        store.commit(StoreMutations.SetOpzioniVisibili, false);
    }

    private applicaModificaFiltro() {
        // TODO
        let filtri: FiltriSpedizioni = {
            numSpedizione: this.filtroNumSpedizione,
            dataSpedizioneDa: this.filtroDataSpedizioneDa,
            dataSpedizioneA: this.filtroDataSpedizioneA
        }
        store.commit(StoreMutations.SetFiltriSpedizioni, filtri);
        store.commit(StoreMutations.SetOpzioniVisibili, false);
    }

    private svuotaFiltro() {
        this.filtroNumSpedizione = '';
        this.filtroDataSpedizioneDa= '';
        this.filtroDataSpedizioneA= '';
        this.filtroDataSpedizioneDaFormatted='';
        this.filtroDataSpedizioneAFormatted='';
    }
//#region gestione negoziazione data
@Watch('filtroDataSpedizioneDa')
    onDateChange(): void {
        this.filtroDataSpedizioneDaFormatted = this.formatDate(this.filtroDataSpedizioneDa)
    }
@Watch('filtroDataSpedizioneA')
    onDataAChange(): void {
        this.filtroDataSpedizioneAFormatted = this.formatDate(this.filtroDataSpedizioneA)
    }
    formatIsoDate(date: string): string {
        if (!date) return '';

        return dayjs(date).format('DD/MM/YYYY');
    }
    formatDate (date: string): string {
        if (!date) return '';

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
    }

    parseDate (date: string): string {
        if (!date) return '';

        const [day, month, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    //#endregion gestione negoziazione data
}

